<template>
  <div class="page flex-col">
    <!-- 顶部导航与底部统一由全局组件渲染，这里仅呈现主体内容 -->
    <div class="intro-container">
      <h1 class="intro-title">成果简介</h1>

      <section class="intro-section">
        <p class="intro-paragraph">
          党的二十大报告将"推进教育强国建设"与"加快发展数字经济"列为中国式现代化的战略重点。与此同时，国家加快建设"制造强国"、"贸易强国"的战略号角全面吹响。跨境电商作为数字贸易核心业态与外贸转型升级的战略引擎，正加速向数据驱动、AI赋能的智能化生态演进，亟需培育大批具备数字技术应用、数据驱动决策与全球化数字运营能力的高技能人才。面对这一时代命题，聚焦国家重点战略，紧密对接安徽省"1188"现代化产业体系及"技能安徽"建设，依托安徽工商职业学院跨境电子商务专业（2016年全省率先开设，2020年正式招生并获批省级高水平专业群），联合合肥荣事达集团、安徽省进出口商会等行业龙头，历经10余年实践探索，构建"标准引领、生态共生、数智驱动、德技互嵌"跨境电商新质技能人才集群培养体系：
        </p>
        <p class="intro-paragraph">
          一是首创构建"标准引领、生态共生"的"三融三共"产教融合新范式。依托产教融合共同体，将产业人才需求标准、国家专业教学标准与头部企业岗位标准动态融通，在融标准、融机制、融资源的基础上，推动校企共建教学资源、共享育人成果、共育技能英才，实现教育链与产业链的有机咬合。
        </p>
        <p class="intro-paragraph">
          二是系统打造"数智驱动、场景赋能"的"三链三化"模块育人新体系。以关键教学要素改革为抓手，推进"课程链+赛证链+育训链"深度融通；通过"内容数智化、载体场景化、能力分级化"的科教融汇路径，系统破解培养协同性弱与实战能力不足的难题。
        </p>
        <p class="intro-paragraph">
          三是着力构筑"德技互嵌、价值闭环"的"三德三匠"协同育人新机制。以"传承古丝路文明互鉴之德、恪守新丝路诚信守规之德、担当数字贸易强国之德"为思政主线，三德铸魂；通过师带徒传承匠艺、国赛实战磨砺匠志、荣事达创客空间丝路项目涵养匠魂，三匠砺能，培育兼具精湛数字技艺与新丝路开拓精神的大国工匠。
        </p>
        <p class="intro-paragraph">
          通过培养体系实施，形成了可复制、可推广的跨境电商高技能人才集群培养"安徽工商方案"，成为全国跨境电商高技能人才培养的主阵地、国家专业教学标准的重要参与制定者、区域跨境电商产业创新发展的核心助推者，在全国高职同类专业中发挥了显著的示范引领作用。
        </p>
      </section>

      <section class="intro-section">
        <figure class="intro-figure">
          <img class="intro-image" src="https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/jj/jjcontent.png" alt="标准引领、生态共生、数智驱动、德技互嵌的跨境电商新质技能人才集群培养体系" />
          <figcaption class="intro-caption">图1 "标准引领、生态共生、数智驱动、德技互嵌"跨境电商新质技能人才集群培养体系</figcaption>
        </figure>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanhuChengguoJianjie'
};
</script>

<style scoped>
/* 页面主容器：统一宽度与居中 */
.intro-container { max-width: 1080px; margin: 36px auto; padding: 0 16px; }
.intro-title { font-size: 24px; font-weight: 700; color: #222; text-align: center; margin-bottom: 24px; }

/* 小节排版 */
.intro-section { margin-bottom: 28px; }
.intro-subtitle { font-size: 18px; font-weight: 600; color: #215195; margin-bottom: 12px; }
.intro-paragraph { font-size: 16px; line-height: 1.9; color: #333; text-align: justify; margin-bottom: 16px; }

/* 图片与图注 */
.intro-figure { margin: 14px 0 8px; }
.intro-image { max-width: 100%; height: auto; border-radius: 6px; box-shadow: 0 6px 18px rgba(0,0,0,0.08); }
.intro-caption { font-size: 14px; color: #666; text-align: center; margin-top: 8px; }

/* 响应式优化 */
@media (max-width: 768px) {
  .intro-title { font-size: 22px; }
  .intro-subtitle { font-size: 17px; }
  .intro-paragraph { font-size: 15px; }
}
</style>
